import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authLoginGuard } from './guards/auth-login.guard';
import { UploadParticipantEvaluationComponent } from './pages/home/sub-pages/sections/training/evaluations/upload-participant-evaluation/upload-participant-evaluation.component';
import { ChangePassComponent } from './pages/permisos/pages/change-pass/change-pass.component';
import { ChangePassComponent as AapCHangePass } from './pages/home/change-pass/change-pass.component';
import { authChangePassGuard } from './guards/auth-change-pass.guard';
import { PoliciesPoliticsComponent } from './pages/policies-politics/policies-politics.component';
import { sistemaGuard } from './guards/sistema.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'system-select',
    loadChildren: () =>
      import('./pages/system_select/system_select.module').then(
        (m) => m.SystemSelectModule,
      ),
    canActivate: [authLoginGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
    canActivate: [authLoginGuard, sistemaGuard],
    data: {
      systemId: 'Hse',
    },
  },
  {
    path: 'permisos',
    loadChildren: () =>
      import('./pages/permisos/permisos.module').then((m) => m.PermisosModule),
    canActivate: [authLoginGuard, sistemaGuard],
    data: {
      systemId: 'Permisos',
    },
  },
  {
    path: 'adminBlister',
    loadChildren: () =>
      import('./pages/admin_blister/admin_blister.module').then(
        (m) => m.AdminBlisterModule,
      ),
    // canActivate: [authLoginGuard],
    data: {
      systemId: 'adminBlister',
    },
  },

  {
    path: 'quality',
    loadChildren: () =>
      import('./pages/quality/quality.module').then((m) => m.QualityModule),
    canActivate: [authLoginGuard, sistemaGuard],
    data: {
      systemId: 'Quality',
    },
  },

  {
    path: 'evaluations/participant',
    component: UploadParticipantEvaluationComponent,
  },
  {
    path: 'change-pass',
    component: ChangePassComponent,
    canActivate: [authChangePassGuard],
  },
  {
    path: 'new-pass',
    component: AapCHangePass,
    canActivate: [authChangePassGuard],
  },
  {
    path: 'politicas',
    title: 'Políticas de cookies',
    component: PoliciesPoliticsComponent,
  },
  {
    path: 'faq',
    title: 'Preguntas frecuentes',
    loadChildren: () =>
      import('./pages/faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: '',
    title: 'No autorizado',
    loadChildren: () =>
      import('./pages/unauthorized/unauthorized.module').then(
        (m) => m.UnauthorizedModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
